<template>
  <div class="login-shell">
    <section class="login-left" aria-hidden="true">
      <div class="brand-panel">
        <!--<div class="brand-mark">OT</div>-->
        <h2 class="brand-name">Obra Tycoon</h2>
        <!--<p class="brand-tagline">Gestão de obras do começo ao fim.</p>
        <ul class="brand-features">
          <li>Cronograma Gantt com dependências</li>
          <li>Almoxarifado e inventário</li>
          <li>DDS e relatórios de segurança</li>
          <li>Chamados e controle de equipe</li>
        </ul>-->
      </div>
    </section>

    <section class="login-right">
      <div class="login-content">
        <div class="login-header">
          <!--<span class="login-product">Obra Tycoon</span>-->
          <h1 class="login-title">Entrar</h1>
          <!--<p class="login-subtitle">Informe a obra e suas credenciais.</p>-->
        </div>

        <form class="form-grid" @submit.prevent="handleLogin">
          <div class="input-field">
            <label for="systemUsername">Identificador da obra</label>
            <input id="systemUsername" v-model="systemUsername" type="text" placeholder="Ex.: relatorioshow" autocomplete="organization" />
          </div>

          <div class="input-field">
            <label for="username">Usuário</label>
            <input id="username" v-model="username" type="text" placeholder="Ex.: gusmachado" autocomplete="username" />
          </div>

          <div class="input-field">
            <label for="password">Senha</label>
            <input id="password" v-model="password" type="password" placeholder="Digite sua senha" autocomplete="current-password" />
          </div>

          <p v-if="error" class="login-error">{{ error }}</p>

          <button class="btn-primary" type="submit" :disabled="loading">{{ loading ? 'Aguarde...' : 'Entrar' }}</button>
          <p v-if="loading" class="login-loading">As informações estão carregando, aguarde um momento.</p>

          <div class="login-links">
            <button class="link-btn" type="button" @click="forgotPassword">Esqueci minha senha</button>
            <span class="link-sep">·</span>
            <button class="link-btn" type="button" @click="goRegister">Registrar obra</button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { sessionStore } from '@/store/session'
import { accountsStore } from '@/store/accounts'
import { versionStore } from '@/store/versionStore'

export default defineComponent({
  name: 'LoginView',
  setup() {
    const router = useRouter()
    const username = ref('')
    const password = ref('')
    const systemUsername = ref('')
    const error = ref('')
    const loading = ref(false)

    const handleLogin = async () => {
      error.value = ''
      if (!username.value.trim() || !password.value.trim()) {
        error.value = 'Informe usuario e senha para continuar.'
        return
      }
      loading.value = true
      try {
        const account = await accountsStore.login(
          username.value.trim(),
          password.value.trim(),
          systemUsername.value.trim().toLowerCase()
        )
        sessionStore.login({
          name: account.name || account.username,
          role: account.role,
          username: account.username,
          systemId: account.systemId,
          systemUsername: account.systemUsername || systemUsername.value.trim().toLowerCase(),
          avatar: account.avatar,
          uid: account.uid,
          roleId: account.roleId,
          subordinateUsernames: account.subordinateUsernames,
          hasSubordinates: account.hasSubordinates,
          isAnalyst: Boolean(account.isAnalyst)
        })
        if ((account as typeof account & { newVersion?: boolean }).newVersion) {
          versionStore.setNewVersion()
        }
        router.push('/home')
      } catch (err: unknown) {
        error.value = err instanceof Error ? err.message : 'Credenciais invalidas.'
      } finally {
        loading.value = false
      }
    }

    const goRegister = () => router.push('/register')
    const forgotPassword = () => router.push('/forgot')

    onMounted(() => {
      if (sessionStore.isLoggedIn.value && sessionStore.state.user) {
        router.push('/home')
      }
    })

    return { username, password, systemUsername, error, loading, handleLogin, goRegister, forgotPassword }
  }
})
</script>

<style scoped lang="scss">
.login-shell {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  overflow: hidden;
}

/* ── LEFT PANEL ── */
.login-left {
  flex: 0 0 42%;
  background: #0d1f35;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
  position: relative;
  overflow: hidden;
}

.login-left::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 20% 50%, rgba(15, 76, 129, 0.5) 0%, transparent 65%),
              radial-gradient(ellipse at 80% 20%, rgba(79, 51, 0, 0.3) 0%, transparent 55%);
  pointer-events: none;
}

.brand-panel {
  position: relative;
  z-index: 1;
  max-width: 320px;
  color: #ffffff;
}

.brand-mark {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: #0f4c81;
  display: grid;
  place-items: center;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.5px;
  color: #fff;
  margin-bottom: 20px;
}

.brand-name {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px;
  letter-spacing: -0.3px;
}

.brand-tagline {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.55);
  margin: 0 0 32px;
  line-height: 1.5;
}

.brand-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;

  li {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
    padding-left: 18px;
    position: relative;
    line-height: 1.4;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 6px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #0f4c81;
    }
  }
}

/* ── RIGHT PANEL ── */
.login-right {
  flex: 1;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 64px;
  min-height: 100vh;
  min-height: 100dvh;
}

.login-content {
  width: 100%;
  max-width: 380px;
}

.login-header {
  margin-bottom: 28px;
}

.login-product {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0f4c81;
  margin-bottom: 10px;
}

.login-title {
  font-size: 26px;
  font-weight: 700;
  margin: 0 0 6px;
  color: #111827;
  letter-spacing: -0.3px;
}

.login-subtitle {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}

.form-grid {
  display: grid;
  gap: 16px;
}

.login-error {
  font-size: 13px;
  color: #b91c1c;
  margin: 0;
  padding: 10px 12px;
  background: #fef2f2;
  border-radius: 8px;
  border: 1px solid #fecaca;
}

.login-loading {
  font-size: 12px;
  color: #605e5c;
  margin: 0;
  text-align: center;
}

.btn-primary {
  background: #0f4c81;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 13px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  margin-top: 4px;
  transition: background 0.15s ease, transform 0.1s ease;

  &:hover {
    background: #0d3f6e;
  }

  &:active {
    transform: scale(0.99);
  }
}

.login-links {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.link-sep {
  color: #d1d5db;
  font-size: 12px;
}

.link-btn {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 13px;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.15s;

  &:hover {
    color: #0f4c81;
  }
}

/* ── RESPONSIVE ── */
@media (max-width: 900px) {
  .login-shell {
    flex-direction: column;
  }

  .login-left {
    flex: 0 0 auto;
    padding: 32px 24px;
    min-height: 200px;
    justify-content: flex-start;
  }

  .brand-mark {
    width: 40px;
    height: 40px;
    font-size: 16px;
    margin-bottom: 12px;
  }

  .brand-name {
    font-size: 22px;
  }

  .brand-tagline {
    font-size: 13px;
    margin-bottom: 0;
  }

  .brand-features {
    display: none;
  }

  .login-right {
    padding: 32px 24px;
    padding-bottom: max(32px, env(safe-area-inset-bottom, 32px));
    align-items: flex-start;
    min-height: auto;
  }
}

@media (max-width: 480px) {
  .login-left {
    padding: 24px 20px;
  }

  .login-right {
    padding: 24px 20px;
    padding-bottom: max(24px, env(safe-area-inset-bottom, 24px));
  }
}
</style>
